import CollegePills from './collegePills';
export default CollegePills;
